import React from 'react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-20" data-mp="gwx5x4ldv9es">
      <Reveal className="mx-auto max-w-3xl" data-id="element-21" data-mp="vsmmuobpowcn">
        <div className="mb-12 text-center" data-id="element-22" data-mp="vuh863qwaqh9">
          <div className="inline-flex rounded-full bg-brand-red/12 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-red" data-id="element-23" data-mp="qtt8yusij3by">
            OFFERTA A TEMPO LIMITATO
          </div>
          <h2 className="mt-4 text-3xl font-extrabold text-brand-blue md:text-4xl" data-id="element-24" data-mp="zuhl1jycitm7">🎁 5 Bonus Esclusivi</h2>
          <p className="mt-4 text-brand-gray" data-id="element-25" data-mp="1ej4awflln3ro">
            Valore totale: <span className="font-bold text-brand-red" data-id="element-26" data-mp="1eim44p1b975i">128 €</span> — inclusi gratuitamente nel pack di
            oggi
          </p>
        </div>
        <div className="space-y-3" data-id="element-27" data-mp="1njkbnhayjwsu">
          {bonuses.map(({
          icon: BonusIcon,
          title,
          price
        }, index) => <article key={title} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-28" data-mp="1jj9vjbtgbq09" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue font-display text-sm font-bold text-white" data-id="element-29" data-mp="3trdsrtmcnb3m">
                {index + 1}
              </span>
              <BonusIcon className="h-7 w-7 shrink-0 text-brand-ochre" strokeWidth={1.6} aria-hidden="true" data-id="element-30" data-mp="7l8izcjp5utu" />
              <div className="min-w-0 flex-1" data-id="element-31" data-mp="cklc2f15vy4v">
                <h3 className="font-bold leading-snug text-brand-blue" data-id="element-32" data-mp="chpggxcsdljl">{title}</h3>
                <p className="mt-1 flex flex-wrap items-center gap-2 text-xs" data-id="element-33" data-mp="gjkgzzmw7uwb">
                  <span className="font-semibold text-brand-gray line-through" data-id="element-34" data-mp="ldexyvb45vrp">{price}</span>
                  <span className="rounded-full bg-brand-green/12 px-2 py-0.5 font-extrabold tracking-wide text-brand-green" data-id="element-35" data-mp="qa5cvfb6mlbj">
                    GRATIS
                  </span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}